<template>
	<div>
		<div class="d-flex justify-content-between">
			<h1 class="page-header">{{ $t('portfolioPhoto.portfolioPreviewList') }}</h1>
			<ts-breadcrumb :items="[
				{ text: $t('toHomePage'), href: '/' },
				{
					text: $t('portfolioPhoto.portfolioPreviewList'),
					active: true
				}
			]" />
		</div>
		<ts-card>
			<ts-card-wrapper>
				<div class="row">
					<div class="col-lg-3 form-group">
						<div class="row ts-mb-2">
							<div class="col-md-12">
								<label class="col-form-label required">{{
									$t('portfolioPhoto.setupDate')
								}}</label>
								<a-range-picker format="DD-MM-YYYY" :defaultValue="rangeDate" :defaultPickerValue="rangeDate"
									@change="dateRangeChange">
									<template slot="renderExtraFooter"></template>
								</a-range-picker>
							</div>
						</div>
						<div class="row ts-mb-2">
							<div class="col-md-12">
								<label class="col-form-label required">{{ $t('portfolioPhoto.acYear') }}</label>
								<a-select v-model="model.ac_year_id" style="width: 100%" :options="years" :show-search="true"
									@change="onYearChange" option-filter-prop="children" :filter-option="(input, option) =>
										option.componentOptions.children[0].text
											.toLowerCase()
											.indexOf(input.toLowerCase()) >= 0
										"></a-select>
							</div>
						</div>
						<div class="row ts-mb-2">
							<div class="col-md-12">
								<label class="col-form-label">{{ $t('portfolioPhoto.academicTerm') }}</label>
								<a-select v-model="model.term_id" style="width: 100%" :options="terms" :show-search="true"
								@change="onTermChange"
									option-filter-prop="children" :filter-option="(input, option) =>
										option.componentOptions.children[0].text
											.toLowerCase()
											.indexOf(input.toLowerCase()) >= 0
										"></a-select>
							</div>
						</div>
						<div class="row form-group ts-mb-2">
							<div class="col-md-12">
								<label class="col-form-label col-md-12" style="margin-left: -12px;">{{
									$t('portfolioPhoto.className')
								}}</label>
								<a-radio-group v-model="acStatusId" @change="onStatusChange" size="small">
									<a-radio-button :value="1">
										{{ $t('portfolioPhoto.current') }}
									</a-radio-button>
									<a-radio-button :value="2">
										{{ $t('portfolioPhoto.history') }}
									</a-radio-button>
								</a-radio-group>
								<a-select v-model="model.class_id" style="width: 100%" :options="classList" @change="onClassChange"
									:show-search="true" option-filter-prop="children" :filter-option="(input, option) =>
										option.componentOptions.children[0].text
											.toLowerCase()
											.indexOf(input.toLowerCase()) >= 0
										"></a-select>
							</div>
						</div>
						<div class="row ts-mb-2">
							<div class="col-md-12">
								<label class="col-form-label">{{ $t('portfolioPhoto.studentName') }}</label>
								<a-select v-model="model.student_id" :placeholder="$t('all')" style="width: 100%" :options="student_list"
									:show-search="true" option-filter-prop="children" :filter-option="(input, option) =>
										option.componentOptions.children[0].text
											.toLowerCase()
											.indexOf(input.toLowerCase()) >= 0
										"></a-select>
							</div>
						</div>
						<div class="row form-group">
							<div class="col-md-12 ts-text-right">
								<ts-button color="primary" @click.prevent="preview" :waiting="waiting">
									{{ $t('portfolioPhoto.preview') }}
								</ts-button>
							</div>
						</div>
					</div>
					<div class="col-lg-9">
						<ts-loading-banner :loading="loading">
							<div v-if="isHasPhoto">
								<div class="ts-bg-gray-100 ts-p-4" v-for="(items, type_date) in photo_list">
									<h2
										class="m-t-5 m-b-5 ts-sticky ts-top-0 ts-z-10 ts-p-2 ts-opacity-90 ts-font-bold ts-font-sans ts-text-sm ts-flex ts-justify-between"
										style="text-shadow: 0 0 3px #fff, 0 0 5px #fff;background: #f5f5f5;">
										<div class="ts-flex ts-justify-start">
											{{ type_date }}
										</div>
									</h2>
									<div class="row row-space-4" v-viewer>
										<div class="col-lg-1 col-sm-2 col-3" v-for="(item, index) in items">
											<a v-if="item.mime_type == 'image/jpg' || item.mime_type == 'image/jpeg' || item.mime_type == 'image/png'"
												class="widget-card square m-b-2 photo-wrapper">
												<img class="widget-card-cover" v-lazy="{
													src: photo(item),
													loading: require('@/assets/Rolling-1s-200px_2.svg')
												}" />
											</a>
											<a v-else
												class="ts-border ts-p-2 ts-rounded-md ts-w-24 ts-h-24 ts-flex ts-items-center ts-justify-center ts-cursor-pointer hover:ts-shadow-md">
												<i class="far fa-file-pdf ts-text-red-600 ts-text-6xl fa-2x" @click="onClickPdf(item)"></i>
											</a>
										</div>
									</div>
								</div>
								<div class="ts-mt-3 ts-text-right">
									<ts-button class="ts-ml-2" outline color="info" @click.prevent="onReleasePortfolio">
										{{ $t('portfolioPhoto.release') }}
									</ts-button>
								</div>
							</div>
							<div v-else style="margin: auto; width: 300px; margin-top:150px">
								<img :src="require('@/assets/cover-scrum-board.png')" />
								<h1 class="text-center ts-text-4xl ts-font-bold ts-opacity-25">
									No Photo
								</h1>
							</div>
							<a-modal v-model="pdfShow" :zIndex="1020" width="40%" style="height: 70vh;"
								:title="$t('portfolioPhoto.preview')" :footer="null" :maskClosable="false">
								<pdfView :resource="pdfData" />
							</a-modal>
						</ts-loading-banner>
					</div>
				</div>
			</ts-card-wrapper>
		</ts-card>
	</div>
</template>
<script>
import moment from 'moment'
import { mapActions } from 'vuex'
import { isEmpty } from 'lodash'
import pdfView from './components/pdf-view.vue'
import VueViewer from 'v-viewer'
import Vue from 'vue'
import 'viewerjs/dist/viewer.css'
Vue.use(VueViewer)

export default {
	name: 'portfolioPreviewList',
	components: {
		pdfView
	},
	data() {
		return {
			rangeDate: [moment().add(-1, 'months'), moment()],
			waiting: false,
			loading: false,
			studentLoading: false,
			releaseLoading: false,
			pdfShow: false,
			pdfData: null,
			student_list: [],
			class_list: [],
			years: [],
			terms: [],
			photo_list: {},
			model: {
				student_id: undefined,
				ac_year_id: undefined,
				term_id: undefined,
				class_id: undefined
			}
		}
	},
	computed: {
		isHasPhoto() {
			return !isEmpty(this.photo_list)
		},
		acStatusId: {
			get() {
				return this.$store.state.portfolioPhoto.ac_status_id
			},
			set(newValue) {
				this.$store.commit(
					'portfolioPhoto/SET_AC_STATUS',
					newValue
				)
			}
		},
		classList() {
			return this.class_list.map(el => ({
				value: el.class_id,
				label: el.class_name
			}))
		},
	},
	created() {
		this.fetchClass();
		this.fetchYear();
	},
	methods: {
		...mapActions('portfolioPhoto', ['getClassOperation']),
		photo(record) {
			if (record.storage_path) {
				return record.storage_path
			}
			return require('@/assets/default_user.jpg')
		},
		pdf(record) {
			if (record.storage_path) {
				return record.storage_path
			}
			return require('@/assets/default_user.jpg')
		},
		dateRangeChange(dateRange) {
			this.$store.commit(
				'portfolioPhoto/SET_DATE_FROM',
				dateRange[0].format('DD-MM-YYYY')
			)
			this.$store.commit(
				'portfolioPhoto/SET_DATE_TO',
				dateRange[1].format('DD-MM-YYYY')
			)
		},
		onStatusChange() {
			this.class_list = []
			this.model.class_id = null
			this.model.student_id = null
			if(this.model.term_id){
				this.getClassOperation({ 
				branch_id: this.$store.state.authUser.default_branch_id,
				ac_term_id: this.model.term_id
				})
					.then(response => {
						this.class_list = response.data
					})
					.catch(error => {
						this.$toasted.error(error.message)
					})
			} else {
				this.fetchClass()
			}
		},
		onTermChange() {
			this.class_list = []
			this.model.class_id = null
			this.model.student_id = null
			this.loading = true
			this.getClassOperation({ 
				branch_id: this.$store.state.authUser.default_branch_id,
				ac_term_id: this.model.term_id
			 })
				.then(response => {
					this.class_list = response.data
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.loading = false
				})
		},
		fetchClass() {
			this.loading = true
			this.getClassOperation({ branch_id: this.$store.state.authUser.default_branch_id })
				.then(response => {
					this.class_list = response.data
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.loading = false
				})
		},
		onClassChange() { 
			this.student_list = []
			this.model.student_id = undefined
			this.fetchStudent()
		},
		fetchStudent() {
			this.studentLoading = true
			this.$store
				.dispatch(
					'portfolioPhoto/getStudentEnrollmentByClass', Object.assign({
						class_id: this.model.class_id,
						branch_id: this.$store.state.authUser.default_branch_id
					})
				)
				.then(response => {
					this.student_list = response.data
						.filter(e => e.student_profile != null)
						.map(el => ({
							value: el.student_profile.student_id,
							label:
								el.student_profile.card_number +
								'|' +
								el.student_profile.full_name_en
						}))
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.studentLoading = false
				})
		},
		fetchYear() {
			this.loading = true
			this.$store
				.dispatch('portfolioPhoto/getYear')
				.then(response => {
					this.years = response.data.map(el => ({
						value: el.ac_year_id,
						label: el.ac_year + (el.ac_status_id == 1 ? ' ( Current ) ' : el.ac_status_id == 2 ? ' ( History ) ' : ' ( Next ) ')
					}))
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.loading = false
				})
		},
		onYearChange() {
			this.terms = []
			this.class_list = []
			this.model.term_id = undefined
			this.model.class_id = null
			this.fetchTerm()
			this.fetchClass()
		},
		fetchTerm() {
			this.loading = true
			this.$store
				.dispatch('portfolioPhoto/getTerm', this.model.ac_year_id)
				.then(response => {
					this.terms = response.data.map(el => ({
						value: el.ac_term_id,
						label: el.term_name
					}))
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.loading = false
				})
		},
		onReleasePortfolio() {
			this.loading = true
			this.uploadList = Object.values(this.photo_list).flat().map(el => el.upload_id)
			this.$store
				.dispatch('portfolioPhoto/releasePortfolio', this.uploadList)
				.then(response => {
					this.$toasted.success(response.message)
				})
				.catch(error => {
					this.$toasted.success(error.message)
				})
				.finally(() => {
					this.loading = false
				})
		},
		preview() {
			this.waiting = true
			this.$store
				.dispatch('portfolioPhoto/previewListPortfolio', this.model)
				.then(response => {
					this.photo_list = response.data
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.waiting = false
				})
		},
		onClickPdf(record) {
			this.pdfShow = true
			this.pdfData = record
		}
	},
}
</script>
<style scoped lang="scss">
.photo-wrapper {
	background: #fff;

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
}

.photo-wrapper:hover img {
	padding: 5px;
	opacity: 0.8;
	-webkit-transition: 0.3s ease-in-out;
	transition: 0.3s ease-in-out;
}
</style>
  